const RESETPASSWORD = {
  heading: {
    title: 'Please, set up your new password',
    submitSucceededText: 'Your password has been successfully changed',
  },
  button: 'Set Up',
};

export default RESETPASSWORD;
